import { useEffect, useState } from 'react';
import RoleList from './RoleList';
import { TabsUI } from '../Interface';
import RoleInformation from './RoleInformation';
import BiRoleInformation from './BiRoleInformation';
import DashboardInformation from './DashboardInformation';
import RoleListIformation from './RoleListInformation';
import RoleDocInformation from './DocRoleInformation';
import useParam from '../../context/ParamContext';
import useUsers from '../../context/UsersContext';

export default function RoleIndex() {
  const { getParam, params } = useParam();
  const { getUser, user } = useUsers();
  const [activeTab, setActiveTab] = useState(0);
  const [roleId, setRoleId] = useState(null);

  useEffect(() => {
    getParam();
    if (!Object.keys(user).length) getUser();
  }, []);

  const tabs = [
    {
      id: 1,
      name: 'Menüpontok',
      content: <RoleInformation roleState={{ roleId, setRoleId }} params={params} user={user} />,
    },
    {
      id: 2,
      name: 'Kimutatások',
      content: <BiRoleInformation roleState={{ roleId, setRoleId }} />,
    },
    {
      id: 3,
      name: 'Dashboard',
      content: <DashboardInformation roleState={{ roleId, setRoleId }} />,
    },
    {
      id: 4,
      name: 'Beállítások',
      content: <RoleListIformation roleState={{ roleId, setRoleId }} />,
    },
    {
      id: 5,
      name: 'Bizonylatok',
      content: <RoleDocInformation roleState={{ roleId, setRoleId }} />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <main className="px-2 pt-1 bg-gray-100 min-h-screen w-full fixed">
      <div className="grid grid-cols-4 mt-5">
        <RoleList roleState={{ roleId, setRoleId }} />
        <div className="col-span-3">
          <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
            {tabs.map((tab, index) => (
              <div key={index} name={tab.name}>
                {tab.content}
              </div>
            ))}
          </TabsUI>
        </div>
      </div>
    </main>
  );
}
